import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const updateContact = async (contactId, details) => {
  const apiURL = API_HOST + '/contacts/' + contactId;
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.patch(apiURL,{
      contact:{
        ...details
      }
    },{
      headers: {
      'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
    }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
